import React, { FC, useState } from 'react';
import Box from '@/components/UI/box/Box';
import { useOpenLoginModal } from '@/hooks/useOpenLoginModal';
import { requestToVisitHouse } from '@/redux/store/actions/product';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import styles from './ProductCardMidTermFooter.module.scss';
import Typography from '@/components/UI/typography/Typography';
import { moneyFormat } from '@/helpers/props';
import Button from '@/components/UI/button/Button';
import { ProductListRecord } from '../types';
interface ProductCardMidTermFooterProps {
  data: ProductListRecord;
  handleOpenHouse: VoidFunction;
}
const ProductCardMidTermFooter: FC<ProductCardMidTermFooterProps> = ({
  data,
  handleOpenHouse
}) => {
  const [loading, setloading] = useState(false);
  const dispatch = useDispatch();
  const router = useRouter();
  const bootstrapData = useSelector(state => state.bootstrapData);
  const {
    setLoginDrawerState
  } = useOpenLoginModal();
  const isLoggedIn = !!bootstrapData?.data?.user_info?.uid;
  const hasCheckinCheckout = router.query.checkin && router.query.checkout;
  const isDiscounted = data?.pricing?.total?.amount !== data?.pricing?.total_without_discount?.amount;
  const isPriceAfterDiscountDifferent = data?.pricing?.price_after_discount?.amount !== data?.pricing?.price_without_discount?.amount;
  const priceAmount = hasCheckinCheckout ? data?.pricing?.total?.amount : data?.pricing?.price_after_discount?.amount;
  const discountedPriceAmount = hasCheckinCheckout ? isDiscounted ? data?.pricing?.total_without_discount?.amount : 0 : isPriceAfterDiscountDifferent ? data?.pricing?.price_without_discount?.amount : 0;
  const discountPercent = (Number(data?.pricing?.price_without_discount?.amount) - Number(data?.pricing?.price_after_discount?.amount)) / Number(data?.pricing?.price_without_discount?.amount) * 100;
  const handleRequestVisit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (!isLoggedIn) {
      setLoginDrawerState({
        open: true,
        message: 'برای ادامه لطفا وارد شوید.'
      });
    } else {
      requestVisit();
    }
  };
  const requestVisit = () => {
    setloading(true);
    dispatch(requestToVisitHouse(Number(data?.id), ({
      error,
      message
    }) => {
      setloading(false);
      if (!error) {
        toast.success('درخواست شما با موفقیت ثبت شد.');
      } else {
        toast.error(message);
      }
    }));
  };
  return <Box component="footer" className={styles['price-container']} onClick={handleOpenHouse} data-sentry-element="Box" data-sentry-component="ProductCardMidTermFooter" data-sentry-source-file="ProductCardMidTermFooter.tsx">
      <Box className={styles['price-section']} data-sentry-element="Box" data-sentry-source-file="ProductCardMidTermFooter.tsx">
        <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="ProductCardMidTermFooter.tsx">
          {hasCheckinCheckout ? 'قیمت کل' : 'اجاره ماهانه'}
        </Typography>
        <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="ProductCardMidTermFooter.tsx">
          <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="ProductCardMidTermFooter.tsx">
            {moneyFormat(priceAmount)}
          </Typography>{' '}
          تومان
        </Typography>
        <Box className={styles['discount-container']} data-sentry-element="Box" data-sentry-source-file="ProductCardMidTermFooter.tsx">
          {!!discountedPriceAmount && <>
              <Typography variant="bodyS" className={styles['discount-percent']}>
                {moneyFormat(discountPercent)}%
              </Typography>
              <Typography variant="bodyS" className={styles['discount']}>
                {moneyFormat(discountedPriceAmount)}
              </Typography>
            </>}
        </Box>
      </Box>
    </Box>;
};
export default ProductCardMidTermFooter;